import { v4 as uuidv4 } from "uuid";
import {
  DEMO_CONTRACT_STORAGE_KEY,
  DEMO_STORAGE_TTL_MS,
} from "../constants/demoContract";

export function savePendingDemoContract(payload) {
  const record = {
    version: 1,
    savedAt: new Date().toISOString(),
    jobId: payload.jobId || uuidv4(),
    templateKey: payload.templateKey,
    documentTitle: payload.documentTitle,
    formData: payload.formData,
  };
  sessionStorage.setItem(DEMO_CONTRACT_STORAGE_KEY, JSON.stringify(record));
  return record;
}

export function loadPendingDemoContract() {
  try {
    const raw = sessionStorage.getItem(DEMO_CONTRACT_STORAGE_KEY);
    if (!raw) return null;

    const record = JSON.parse(raw);
    if (
      !record?.templateKey ||
      !record?.formData ||
      Date.now() - new Date(record.savedAt).getTime() > DEMO_STORAGE_TTL_MS
    ) {
      clearPendingDemoContract();
      return null;
    }

    return record;
  } catch {
    return null;
  }
}

export function clearPendingDemoContract() {
  sessionStorage.removeItem(DEMO_CONTRACT_STORAGE_KEY);
}
